<template>
  <div class="vcenter">
    <el-form class="login-form" ref="form" :model="form" status-icon :rules="rules" v-loading="loading"
      size="medium" @keyup.enter.native="submitForm('form')">
      <div><label for="loginName">We will send an email with next steps to get a new Password. <br><br> Enter Your Email :</label></div>
      <el-form-item prop="loginName">
        <el-input v-model="form.loginName" placeholder="Email"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small"  style="width:50%; margin-left:25%; font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="submitForm('form')">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import HTTP_API from '@/utils/http-api'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      form: { },
			rules: {
				loginName: [{ required: true, message: 'Email is required' }]
      },
      loading: false,
      user: { loginName: ''}
    }
  },
  methods: {
    submitForm(formName) {
      var vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.loading = true
          HTTP_API.post('/account/forgotPassword', this.form)
          .then(function (response) {
            console.log(response)
            vm.resetAllFlag()
            vm.$message.success({ message: 'Please check your inbox for instructions on resetting your password. \n If you don\'t receive an email, please ensure your email address is correct.', duration: 3000})
            vm.$router.push({ name: "login" })
          })
          .catch(function (error) {
            console.log(error)
            vm.resetAllFlag()
            vm.$message.error({ message: 'Unable to send email.' })
          })
        } else {
          console.log('Validation failed')
          return false
        }
      })
    },
    resetAllFlag() {
      this.loading = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .vcenter {
    position: absolute;
    margin: 0;
    top: 53%;
    left: 50%;
    -ms-transform: translate(-50%, -47%);
    transform: translate(-50%, -47%);
    width: 500px;
    color: #606266;
    background-color: #f2f2f2;
  }

  .login-icon {
    padding-right: 10px;
  }

  .login-header {
    text-align: center;
    margin-top: 0px;
    font-family: "Courier New";
  }

  .login-form {
    border-radius: 5px;
    padding: 22px 22px;
    /* background: rgba(255, 255, 255, .9); */
    opacity: 0.96;
    box-shadow: 0 2px 6px 1px #666666;
  }

</style>
